import { useState } from "react";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import AboutImg1 from '../../assets/images/resources/about-one-img-1.png';
import AboutShape3 from '../../assets/images/shapes/about-shape-3.png';
import AboutShape1 from '../../assets/images/shapes/about-shape-1.png';
import AboutShape2 from '../../assets/images/shapes/about-shape-2.png';
import AboutShape4 from '../../assets/images/shapes/about-shape-4.png';
import clientImg1 from '../../assets/images/resources/about-one-happy-client-img-1.jpg';
import clientImg2 from '../../assets/images/resources/about-one-happy-client-img-2.jpg';
import clientImg3 from '../../assets/images/resources/about-one-happy-client-img-3.jpg';

export default function About() {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleOnClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <>
      {/* About One Start */}
      <section className="about-one" id="about">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6">
              <div
                className="about-one__left wow slideInLeft"
                data-wow-delay="100ms"
                data-wow-duration="2500ms"
              >
                <div className="about-one__img">
                  <img
                    src={AboutImg1}
                    alt=""
                  />
                  <div className="about-one__shape-3">
                    <img
                      src={AboutShape3}
                      alt=""
                    />
                  </div>
                  <div className="about-one__shape-4">
                    <img
                      src={AboutShape4}
                      alt=""
                    />
                  </div>
                  <div className="about-one__shape-1">
                    <img
                      src={AboutShape1}
                      alt=""
                    />
                  </div>
                  <div className="about-one__shape-2">
                    <img
                      src={AboutShape2}
                      alt=""
                    />
                  </div>
                  {/* <div className="about-one__happy-client">
                    <div className="about-one__client-img-box">
                      <ul className="about-one__client-img-list list-unstyled">
                        <li>
                          <div className="about-one__client-img">
                            <img
                              src={clientImg1}
                              alt=""
                            />
                          </div>
                        </li>
                        <li>
                          <div className="about-one__client-img">
                            <img
                              src={clientImg2}
                              alt=""
                            />
                          </div>
                        </li>
                        <li>
                          <div className="about-one__client-img">
                            <img
                              src={clientImg3}
                              alt=""
                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="about-one__happy-client-content">
                      <div className="about-one__count count-box">
                        <h3 className="count-text">
                          <CountUp end={2000} duration={1.5} />
                        </h3>
                        <span className="about-one__count-plus">+</span>
                      </div>
                      <p className="about-one__count-text">Happy Clients</p>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="about-one__right">
                <div className="section-title text-left">
                  <div className="section-title__tagline-box">
                    <span className="section-title__tagline">About Us</span>
                  </div>
                  {/* <h2 className="section-title__title2 ">
                    With more than two decades of experience,Ramana International is recognized as a leading name in the industry.
                  </h2> */}
                </div>
                <div className="about-one__main-tab-box tabs-box">

                  <div className="tabs-content">
                    {/* Tab */}
                    <div
                      className={`tab ${activeIndex === 0 ? "active-tab" : ""}`}
                      id="skills"
                    >
                      <div className="about-one__tab-content-box">
                        <p className="about-one__text-1">
                          <strong> Ramana Steels – Innovating Industries, Empowering Progress</strong><br />
                          As a proud subsidiary of <strong> Ramana Machines, Ramana Steels</strong> stands at the forefront of high-grade steel solutions and advanced scrap processing machinery. We serve key industries like <strong> ISPAT, TMT bar manufacturing, and scrap yards</strong>, providing cutting-edge technology that enhances metal recycling and industrial efficiency.<br />
                          Our <strong> state-of-the-art machinery </strong>ensures precision, sustainability, and innovation, making us a trusted name in the steel and recycling sector. With a strong presence in <strong>India and across the globe</strong>, we are dedicated to delivering <strong> world-class solutions</strong> tailored to the evolving needs of global industries.
                          At Ramana Steels, we don’t just process metal—we <strong>reshape the future of industrial excellence</strong>. Partner with us and experience  <strong>sustainability, precision, and unmatched expertise</strong> in every solution we offer!


                          {/* With more than two decades of experience,<strong>Ramana International</strong> is recognized as a leading name in the industry.<br />
                          Founded in 2013 under the visionary leadership of <strong>Mr. Parmesh Wassist, Ramana Machines </strong> has established itself as a trusted provider of advanced <strong>textile and industrial machinery</strong>. Renowned for our cutting-edge technology and unmatched service, we not only deliver high-quality machinery but also offer <strong> 24/7 comprehensive support</strong> to ensure seamless operations for our clients.<br />
                          Expanding beyond machinery,<strong> Ramana Steels</strong>, a subsidiary of Ramana Machines, specializes in high-grade <strong> steel solutions </strong>and <strong>scrap processing machines</strong>, catering to industries such as<strong> ISPAT, TMT bar manufacturing, and scrap yards</strong>. Our state-of-the-art technology ensures<strong> efficient metal recycling and processing</strong>, reinforcing our commitment to sustainability and industrial innovation.<br />
                          With offices across <strong>India</strong> and a branch in <strong>China</strong>, we are committed to delivering cutting-edge solutions to industries worldwide, including <strong>textile, steel, footwear, healthcare, agriculture, construction</strong>, and more. */}
                        </p>


                      </div>
                    </div>

                  </div>
                </div>
                <div className="about-one__shape-5">
                  <img src="/assets/images/shapes/about-shape-5.png" alt="" />
                </div>
              </div>
            </div>
            <div className="d-flex tagline-media col-xl-12 col-lg-12">
              <div className="testimonial-two__single shadow p-3 mb-3 bg-gray" /* style={{ marginRight: '15px' }} */>
                {/* <div className="testimonial-two__quote">
                              <span className="icon-quote"></span>
                            </div> */}
                <div className="testimonial-two__client-info">
                  {/* <div className="testimonial-two__client-img">
                              <img src={testimonial.imgSrc} alt={testimonial.name} />
                            </div> */}
                  <div className="testimonial-two__client-content">
                    <div className="section-title__tagline-box">
                      <h3>  Our vision</h3>
                    </div>
                  </div>
                </div>
                <p className="testimonial-two__text">
                  To be the most trusted supplier <br />and importer of innovative<br /> machinery, adding value to<br /> industries across the globe.
                </p>

              </div>
              <div className="testimonial-two__single shadow p-3 mb-3 bg-gray" /* style={{ marginRight: '15px' }} */>
                {/* <div className="testimonial-two__quote">
                              <span className="icon-quote"></span>
                            </div> */}
                <div className="testimonial-two__client-info">
                  {/* <div className="testimonial-two__client-img">
                              <img src={testimonial.imgSrc} alt={testimonial.name} />
                            </div> */}
                  <div className="testimonial-two__client-content">
                    <h3><span>Our Mission</span></h3>
                    {/* <p>{testimonial.company}</p> */}
                  </div>
                </div>
                <p className="testimonial-two__text">
                  To provide exceptional solutions <br />that empower businesses while <br />leading the way in technological<br /> advancements.
                </p>

              </div>
              <div className="testimonial-two__single shadow p-3 mb-3 bg-gray" >
                {/* <div className="testimonial-two__quote">
                              <span className="icon-quote"></span>
                            </div> */}
                <div className="testimonial-two__client-info">
                  {/* <div className="testimonial-two__client-img">
                              <img src={testimonial.imgSrc} alt={testimonial.name} />
                            </div> */}
                  <div className="testimonial-two__client-content">
                    <div className="testimonial-two__client-content">
                      <div className="section-title__tagline-box mb-2">
                        <h3>  Our Core Values</h3>
                      </div>
                    </div>
                    <p> <div className="testimonial-two__client-content">
                      <div className="section-title__tagline-box ">
                        <p style={{ fontSize: "22px" }}>

                          Integrity,<br />Quality,<br />Reliability,<br /> Teamwork,<br />Trust,<br />Health, Safety & Environment (HSE).
                        </p>
                        {/* <span className="section-title__tagline d-flex mb-2"><strong>Integrity</strong></span>
                        <span className="section-title__tagline d-flex mb-2"><strong>Quality</strong></span>
                        <span className="section-title__tagline d-flex mb-2"><strong>Reliability</strong></span>
                        <span className="section-title__tagline d-flex mb-2"><strong>Teamwork</strong></span>
                        <span className="section-title__tagline d-flex mb-2"><strong>Trust</strong></span>
                        <span className="section-title__tagline d-flex"><strong>Health, Safety & Environment (HSE)</strong></span> */}
                      </div>
                    </div></p>
                  </div>
                </div>
                <p className="testimonial-two__text">

                </p>
              </div>
            </div>
          </div>
        </div>
      </section >
      {/* About One End */}
    </>
  );
}
